import { render } from "./LogDownload.vue?vue&type=template&id=882b3170"
import script from "./LogDownload.vue?vue&type=script&lang=js"
export * from "./LogDownload.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akiowatanabe/work_space/secure_link/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__